export default __webpack_public_path__ + "src/images/about/MediaKit-04760ddb3ec00a85242397d3c42e27e0.png";